export default __webpack_public_path__ + "static/media/phone.afb6a097.svg";